import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import PageHero from '../../components/base/PageHero';

export default function ShopPage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "CollectionPage",
      "name": "ショップ - ジュエリーおかやま",
      "description":
        "岡山市のジュエリーおかやまのジュエリーコレクション。リング、ネックレス、ピアス、ブレスレットなど豊富な品揃え。",
      "url": `${siteUrl}/shop`,
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const products = [
    {
      id: 1,
      name: 'ダイヤモンドリング',
      price: 180000,
      category: 'ring',
      feature: '最高品質のブリリアントカットダイヤモンドを使用。プラチナ台座が上品な輝きを引き立てます。',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/5602039ff27197165907251fd39c362a.jpeg',
    },
    {
      id: 2,
      name: 'パールネックレス',
      price: 95000,
      category: 'necklace',
      feature: '厳選されたアコヤ真珠を一粒ずつ丁寧に連ねた逸品。冠婚葬祭にも普段使いにも。',
      image: 'https://public.readdy.ai/ai/img_res/831055342a0d3b1379a5a241bff0b1be.jpg',
    },
    {
      id: 3,
      name: 'サファイアペンダント',
      price: 125000,
      category: 'necklace',
      feature: '深みのあるロイヤルブルーのサファイアが胸元を華やかに彩る、存在感のあるペンダント。',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20sapphire%20pendant%20with%20deep%20blue%20gemstone%20on%20white%20display%20stand%20soft%20studio%20lighting%20cream%20background%20luxury%20jewelry&width=600&height=700&seq=shop3&orientation=portrait',
    },
    {
      id: 4,
      name: 'ゴールドブレスレット',
      price: 68000,
      category: 'bracelet',
      feature: '繊細なチェーンデザインが手元を上品に演出。18金の温かみのある色合いが魅力です。',
      image: 'https://readdy.ai/api/search-image?query=delicate%20gold%20bracelet%20with%20refined%20chain%20design%20on%20white%20display%20stand%20soft%20studio%20lighting%20cream%20background%20luxury%20jewelry&width=600&height=700&seq=shop4&orientation=portrait',
    },
    {
      id: 5,
      name: 'エメラルドリング',
      price: 210000,
      category: 'ring',
      feature: '鮮やかなグリーンが目を引くコロンビア産エメラルド。ダイヤモンドの取り巻きが華やかさをプラス。',
      image: 'https://readdy.ai/api/search-image?query=stunning%20emerald%20ring%20with%20green%20gemstone%20on%20white%20display%20stand%20soft%20studio%20lighting%20cream%20background%20luxury%20jewelry&width=600&height=700&seq=shop5&orientation=portrait',
    },
    {
      id: 6,
      name: 'プラチナピアス',
      price: 85000,
      category: 'earring',
      feature: 'プラチナの上品な光沢とダイヤモンドの煌めきが耳元を美しく飾る、シンプルで洗練されたデザイン。',
      image: 'https://readdy.ai/api/search-image?query=elegant%20platinum%20earrings%20with%20diamonds%20on%20white%20display%20stand%20soft%20studio%20lighting%20cream%20background%20luxury%20jewelry&width=600&height=700&seq=shop6&orientation=portrait',
    },
    {
      id: 7,
      name: 'ルビーペンダント',
      price: 145000,
      category: 'necklace',
      feature: '情熱的な赤が印象的なミャンマー産ルビー。特別な日の装いにふさわしい一品です。',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/fced887725b74947687a9e2dd5967a66.jpeg',
    },
    {
      id: 8,
      name: 'シルバーバングル',
      price: 42000,
      category: 'bracelet',
      feature: 'シンプルながらも存在感のあるフォルム。日常使いしやすく、どんなスタイルにも合わせやすい万能アイテム。',
      image: 'https://readdy.ai/api/search-image?query=elegant%20silver%20bangle%20with%20refined%20design%20on%20white%20display%20stand%20soft%20studio%20lighting%20cream%20background%20luxury%20jewelry&width=600&height=700&seq=shop8&orientation=portrait',
    },
    {
      id: 9,
      name: 'アクアマリンリング',
      price: 98000,
      category: 'ring',
      feature: '透き通るような淡いブルーが清涼感を演出。春夏の装いにぴったりの爽やかなリングです。',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20aquamarine%20ring%20with%20light%20blue%20gemstone%20on%20white%20display%20stand%20soft%20studio%20lighting%20cream%20background%20luxury%20jewelry&width=600&height=700&seq=shop9&orientation=portrait',
    },
    {
      id: 10,
      name: 'ダイヤモンドピアス',
      price: 155000,
      category: 'earring',
      feature: '一粒ダイヤが耳元で美しく揺れるドロップデザイン。フォーマルからカジュアルまで幅広く活躍。',
      image: 'https://readdy.ai/api/search-image?query=stunning%20diamond%20earrings%20with%20brilliant%20stones%20on%20white%20display%20stand%20soft%20studio%20lighting%20cream%20background%20luxury%20jewelry&width=600&height=700&seq=shop10&orientation=portrait',
    },
    {
      id: 11,
      name: 'トパーズネックレス',
      price: 78000,
      category: 'necklace',
      feature: '温かみのあるゴールデントパーズが胸元に優しい輝きを添える、秋冬にぴったりのネックレス。',
      image: 'https://readdy.ai/api/search-image?query=elegant%20topaz%20necklace%20with%20golden%20gemstone%20on%20elegant%20display%20stand%20soft%20natural%20lighting%20cream%20background%20luxury%20jewelry&width=600&height=700&seq=shop11&orientation=portrait',
    },
    {
      id: 12,
      name: 'ホワイトゴールドリング',
      price: 132000,
      category: 'ring',
      feature: 'ホワイトゴールドの洗練された輝きが指元を美しく演出。シンプルで飽きのこないデザインが人気。',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20white%20gold%20ring%20with%20elegant%20design%20on%20white%20display%20stand%20soft%20studio%20lighting%20cream%20background%20luxury%20jewelry&width=600&height=700&seq=shop12&orientation=portrait',
    },
  ];

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <PageHero
          title="ジュエリー販売"
          subtitle="店舗で販売しているジュエリーコレクション"
          image="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/6b92be77e92b91b6a284795960b9d240.jpeg"
        />

        <section className="py-20 lg:py-28 bg-cream-100">
          <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
            <div className="mb-8">
              <p className="text-brown-600 font-serif">
                {products.length}件の商品
              </p>
            </div>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8" data-product-shop>
              {products.map((product) => (
                <article
                  key={product.id}
                  className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
                >
                  <div className="w-full h-72">
                    <img
                      src={product.image}
                      alt={`${product.name} - 岡山のジュエリーおかやま`}
                      title={`${product.name} ジュエリーおかやま`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-5 text-center">
                    <h3 className="text-lg font-serif font-semibold text-brown-600 mb-1">
                      {product.name}
                    </h3>
                    <p className="text-base font-serif text-brown-400 mb-3">
                      ¥{product.price.toLocaleString()}
                    </p>
                    <p className="text-sm font-serif text-brown-500 leading-relaxed">
                      {product.feature}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* Visit CTA Section */}
        <section className="py-20 lg:py-28 bg-brown-400">
          <div className="max-w-[900px] mx-auto px-6 lg:px-12 text-center">
            <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-serif font-semibold text-white mb-6 leading-tight">
              実際のアイテムをお手元でご覧ください
            </h2>
            <p className="text-lg md:text-xl text-white/90 leading-relaxed mb-8 font-serif">
              写真だけでは伝わらない輝きや質感を、ぜひ店舗でお確かめください。<br />
              スタッフが丁寧にご案内いたします。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
              <a
                href="tel:086-012-3456"
                className="w-full sm:w-auto flex items-center justify-center gap-3 px-8 py-4 bg-white text-brown-600 rounded-lg hover:bg-cream-100 transition-all font-serif text-lg shadow-lg whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                <span>086-012-3456</span>
              </a>
              <Link
                to="/contact"
                className="w-full sm:w-auto px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white hover:text-brown-600 transition-all font-serif text-lg whitespace-nowrap cursor-pointer"
              >
                来店予約・お問い合わせ
              </Link>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-8 text-white/80 font-serif text-base">
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-map-pin-line text-lg"></i>
                </div>
                <span>岡山市北区表町1-2-3</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-time-line text-lg"></i>
                </div>
                <span>9:00〜18:00（土曜・祝日定休）</span>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
